import { useEffect, useState } from 'react';
import { IProduct } from '../types/Product';
import {
  CART_KEY,
  TOTAL_KEY,
  TOTAL_PRICE_KEY,
} from '../constants/localStorageKeys';
import { getLocalStorageData } from '../utils/utils';

const useCart = () => {
  const { storedCartItems, storedTotal, storedPrice } = getLocalStorageData();
  const [cartItems, setCartItems] = useState<IProduct[]>(storedCartItems);
  const [cartTotalItems, setCartTotalItems] = useState<number>(storedTotal);
  const [cartTotalPrice, setCartTotalPrice] = useState<number>(storedPrice);
  const addToCart = (item: IProduct) => {
    const existingItemIndex = cartItems.findIndex(
      (cartItem) => cartItem.id === item.id,
    );
    const hasExistingItem = existingItemIndex > -1;
    const quantity = hasExistingItem
      ? (cartItems[existingItemIndex].quantity as number) + 1
      : 1;
    const newItem = hasExistingItem
      ? {
          ...cartItems[existingItemIndex],
          quantity,
        }
      : {
          ...item,
          quantity,
        };

    setCartItems((currItems) => {
      if (!hasExistingItem) return [...currItems, newItem];

      const updatedCart = [...currItems];
      updatedCart.splice(existingItemIndex, 1, newItem);

      return updatedCart;
    });
    setCartTotalItems((prevValue) => prevValue + 1);
    setCartTotalPrice((prevValue) => prevValue + item.price);
  };
  const removeFromCart = (item: IProduct) => {
    const existingItemIndex = cartItems.findIndex(
      (cartItem) => cartItem.id === item.id,
    );

    if (existingItemIndex < 0) return;

    const updatedCart = [...cartItems];
    const itemToRemove = updatedCart[existingItemIndex];

    if ((itemToRemove?.quantity as number) > 1) {
      itemToRemove.quantity = (itemToRemove.quantity as number) - 1;
    } else {
      updatedCart.splice(existingItemIndex, 1);
    }

    setCartItems(updatedCart);
    setCartTotalItems((prevValue) => prevValue - 1);
    setCartTotalPrice((prevValue) => prevValue - itemToRemove.price);
  };

  useEffect(() => {
    localStorage.setItem(CART_KEY, JSON.stringify(cartItems));
  }, [cartItems]);

  useEffect(() => {
    localStorage.setItem(TOTAL_KEY, JSON.stringify(cartTotalItems));
  }, [cartTotalItems]);

  useEffect(() => {
    localStorage.setItem(TOTAL_PRICE_KEY, JSON.stringify(cartTotalPrice));
  }, [cartTotalPrice]);

  return {
    cartItems,
    cartTotalItems,
    cartTotalPrice,
    removeFromCart,
    addToCart,
  };
};

export default useCart;
